import React, { Fragment, PureComponent } from 'react';
import { connect } from "react-redux";
import PropTypes from 'prop-types';
import "react-datepicker/dist/react-datepicker.css";
import MUIDataTable from "mui-datatables";
import { Button } from 'reactstrap';

import {
	FormGroup,
	Label,
	
} from 'reactstrap';

// rct card box
import RctCollapsibleCard from 'Components/RctCollapsibleCard/RctCollapsibleCard';


import { 
    fetchRangeWedgePlay,
    fetchRangeChipping,
    fetchRangeBunkerPlay
 } from 'Actions';

 import AddItem from '../../../rangeintervention/shortgame/component/addform';

class ShortItems extends React.Component {
  
    static propTypes = {
        classes: PropTypes.object,
        prev:0,

    };

    UNSAFE_componentWillMount() {
	}
    constructor(props) {
      
        super(props);
        this.state = {  
            student: this.props.data.student, 
            startdate:this.props.data.startdate,
            enddate:this.props.data.enddate,  
            listdiv:true,
            adddiv:false,
            selfrom:0,               
        };

        this.onPrevSection = this.onPrevSection.bind(this); 
    }

    onPrevSection(){
        var student=this.state.student;
        var stdate=this.state.startdate;
        var eddate=this.state.enddate;
        this.props.fetchRangeWedgePlay(student, stdate, eddate);
        this.props.fetchRangeChipping(student, stdate, eddate);
        this.props.fetchRangeBunkerPlay(student, stdate, eddate);

        this.setState({
            adddiv:false,
            listdiv:true, 
        }); 
    }

    onAddSession(seltid) {
		this.setState({ 
         selfrom:seltid,
         listdiv:false,
         adddiv:true,
      });
    }



render() {
      
    const { rangewedgeplaylist, rangechippinglist, rangebunkerplaylist, loading} = this.props; 
    const options = {
        filterType: 'dropdown',
        rowsPerPage: 50,
        rowsPerPageOptions: [50, 100, 150],
        selectableRowsHideCheckboxes: true,
    };

    const columns = [
        { name: "no", label: "NO" },
        { name: "date", label: "DATE" },
        { name: "coach", label: "COACH" },
        { name: "obsert", label: "OBSERVATION" },
        { name: "work", label: "WORK IN PROGRESS" },
      
    ];

    const tabledata1=rangewedgeplaylist.map((assmntval,idx) => {     
        
   
        return {
            no:idx+1,
            date: assmntval.cdate,
            coach: assmntval.gri_coachname,
            obsert:assmntval.gri_observation,
            work:assmntval.gri_workinprocess,
        }
    });

    const tabledata2=rangechippinglist.map((assmntval,idx) => {     
       
   
        return {
            no:idx+1,
            date: assmntval.cdate,
            coach: assmntval.gri_coachname,
            obsert:assmntval.gri_observation,
            work:assmntval.gri_workinprocess,
        }
    });

    const tabledata3=rangebunkerplaylist.map((assmntval,idx) => {     
        
   
        return {
            no:idx+1,
            date: assmntval.cdate,
            coach: assmntval.gri_coachname,
            obsert:assmntval.gri_observation,
            work:assmntval.gri_workinprocess,
        }
    });


      return(
            <div>
                <div className="col-md-12 col-lg-12 col-sm-12">
                    <h1 className="text-center" style={{padding:"20px"}}> SHORT GAME</h1>
                </div>
                <div className="col-md-12 col-lg-12 col-sm-12" style={{marginBottom:"10px"}}>
                    <div className="ddd">
                        <div className="float-right"><Button onClick={this.props.onClick} className="btn btn-outline-warning"><i className="zmdi ti-angle-double-left"></i>  Back To Range</Button></div>
                        
                    </div>
                </div>
                {this.state.listdiv && 
                   <>

                    <div className="col-sm-12 col-md-12">
                        <RctCollapsibleCard heading="WEDGE PLAY" fullBlock>
                        <MUIDataTable
                                title={<div><Button onClick={ ()=>this.onAddSession(1)} className="btn btn-outline-info"><i className="zmdi zmdi-plus-circle-o"></i>  Add Wedge Play Intervention</Button></div>}
                                data={tabledata1}
                                columns={columns}
                                options={options} 
                        />   
                        </RctCollapsibleCard>
                    </div>
                    <div className="col-sm-12 col-md-12">
                        <RctCollapsibleCard heading="CHIPPING" fullBlock>
                        <MUIDataTable
                                title={<div><Button onClick={ ()=>this.onAddSession(2)} className="btn btn-outline-info"><i className="zmdi zmdi-plus-circle-o"></i>  Add Chipping Intervention</Button></div>}
                                data={tabledata2}
                                columns={columns}
                                options={options} 
                        />   
                        </RctCollapsibleCard>
                    </div>
                    <div className="col-sm-12 col-md-12">
                        <RctCollapsibleCard heading="BUNKER PLAY" fullBlock>
                        <MUIDataTable
                                title={<div><Button onClick={ ()=>this.onAddSession(3)} className="btn btn-outline-info"><i className="zmdi zmdi-plus-circle-o"></i>  Add Bunker Play Intervention</Button></div>}
                                data={tabledata3}
                                columns={columns}
                                options={options} 
                        />   
                        </RctCollapsibleCard>
                    </div>
                    </>
                }

                {this.state.adddiv && 
                   <AddItem onClick={this.onPrevSection} data={this.state}/> 
                }
            </div>

              
    )
   
}
 
}

const mapStateToProps = ({ rangeshortgame}) => {
   
    const { rangewedgeplaylist, rangechippinglist, rangebunkerplaylist, loading } = rangeshortgame;
	return {  rangewedgeplaylist, rangechippinglist, rangebunkerplaylist, loading };   
}


export default connect(mapStateToProps, {
    fetchRangeWedgePlay,
    fetchRangeChipping,
    fetchRangeBunkerPlay
})(ShortItems);
